import React from 'react';
import { MuiBox, InputField, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';
import { FeeInputProps } from '../types';

const FeeInput: React.FC<FeeInputProps> = ({
  label,
  amount,
  percentage,
  onAmountChange,
  onPercentageChange,
  disabled
}) => {
  const classes = useStyles();
  const isValidDecimal = (value: string) => /^(\d+(\.\d{0,2})?)?$/.test(value);
  const [amountInput, setAmountInput] = React.useState<string>('');
  const [percentageInput, setPercentageInput] = React.useState<string>('');

  React.useEffect(() => {
    if (amount !== null && amount !== undefined) {
      setAmountInput(String(amount));
    } else {
      setAmountInput('');
    }
  }, [amount]);

  React.useEffect(() => {
    if (percentage !== null && percentage !== undefined) {
      setPercentageInput(String(percentage));
    } else {
      setPercentageInput('');
    }
  }, [percentage]);

  const handleAmountChange = (value: string) => {
    if (!isValidDecimal(value)) return;
    const num = value ? Number(value) : null;
    if (num !== null && num < 0) return;
    setAmountInput(value);
    onAmountChange(num);
  };

  const handleAmountBlur = () => {
    if (!amountInput) return;

    const formatted = Number(amountInput).toFixed(2);

    setAmountInput(formatted);
    onAmountChange(Number(formatted));
  };

  const handlePercentageChange = (value: string) => {
    if (!isValidDecimal(value)) return;
    const num = value ? Number(value) : null;

    if (num !== null && (num < 0 || num > 100)) return;

    setPercentageInput(value);
    onPercentageChange(num);
  };

  const handlePercentageBlur = () => {
    if (!percentageInput) return;
    const formatted = Number(percentageInput).toFixed(2);

    setPercentageInput(formatted);
    onPercentageChange(Number(formatted));
  };

  return (
    <MuiBox>
      <Typography className={classes.formLabel}>{label}</Typography>
      <MuiBox display="flex" gap="16px" className={classes.formBox}>
        <MuiBox>
          <InputField
            align="right"
            label="Amount"
            type="number"
            value={amountInput}
            disabled={disabled}
            onChange={(e) => handleAmountChange(e.target.value)}
            startIcon="$"
            size="small"
            sx={{
              width: { xs: '262px', sm: '175px!important' },
              height: '45px',
              '& input[type=number]': {
                MozAppearance: 'textfield'
              },
              '& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              },
              '& input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              }
            }}
            onBlur={handleAmountBlur}
          />
        </MuiBox>
        <MuiBox>
          <InputField
            align="right"
            type="number"
            label="Percentage"
            value={percentageInput}
            disabled={disabled}
            onChange={(e) => handlePercentageChange(e.target.value)}
            endIcon="%"
            size="small"
            sx={{
              width: { xs: '262px', sm: '175px' },
              height: '45px',
              '& input[type=number]': {
                MozAppearance: 'textfield'
              },
              '& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              },
              '& input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              }
            }}
            onBlur={handlePercentageBlur}
          />
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

export default FeeInput;
